// extracted by mini-css-extract-plugin
export var error = "input_error__2gw9F";
export var formInput = "input_formInput__38zEd";
export var formInputLabel = "input_formInputLabel__u4J4f";
export var formInputSpan = "input_formInputSpan__gV68M";
export var formInputSpanError = "input_formInputSpanError__FtSSs";